function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.09,351,93,351.3c-4.74.08-9.52.16-14.3.16h-.45V351l0-11.19v-.5h.5l14.18.06c4.73,0,9.46.12,14.18.17h.28v.26Zm0,0-.26-11.19.26.27c-4.72.05-9.45.16-14.18.17l-14.18.06.5-.5,0,11.19-.45-.44c4.67,0,9.35.08,14.06.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.27,365.12l-14.07.29c-4.73.08-9.51.16-14.3.16h-.44v-.45l-.05-11.19v-.5h.5l14.19.06c4.73,0,9.45.12,14.18.17h.27v.26Zm0,0L91,353.93l.26.27c-4.73.05-9.45.16-14.18.17l-14.19.06.5-.5,0,11.19-.45-.44c4.68,0,9.35.08,14.07.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.73,275.2l-14.06.28c-4.74.08-9.52.16-14.3.17h-.45v-.45L311.87,264v-.5h.51l14.18.06c4.73,0,9.45.12,14.18.17H341V264Zm0,0L340.47,264l.26.26c-4.73.06-9.45.16-14.18.17l-14.18.07.49-.5-.05,11.19-.44-.45c4.67,0,9.34.09,14.06.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.76,275.2l-14.07.28c-4.73.08-9.51.16-14.3.17H280v-.45L279.89,264v-.5h.5l14.19.06c4.73,0,9.45.12,14.18.17H309V264Zm0,0L308.5,264l.26.26c-4.73.06-9.45.16-14.18.17l-14.19.07.5-.5-.05,11.19-.45-.45c4.68,0,9.35.09,14.07.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.78,289.31l-14.07.28c-4.74.08-9.51.16-14.3.17H296v-.45l0-11.19v-.5h.5l14.19.06c4.72,0,9.45.12,14.18.17h.27v.26Zm0,0-.27-11.19.27.26c-4.73.06-9.46.16-14.18.17l-14.19.07.5-.5-.05,11.19-.45-.45c4.68,0,9.35.09,14.07.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.1,365.12l-14.07.29c-4.74.08-9.52.16-14.3.16h-.45v-.45l0-11.19v-.5h.5l14.18.06c4.73,0,9.46.12,14.19.17h.27v.26Zm0,0-.27-11.19.27.27c-4.73.05-9.46.16-14.19.17l-14.18.06.5-.5-.05,11.19-.45-.44c4.67,0,9.35.08,14.07.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.27,81.29l-14.06.28c-4.74.08-9.52.16-14.3.16h-.45v-.45l0-11.18v-.51h.51l14.18.06c4.73,0,9.45.12,14.18.17h.27v.27Zm0,0L421,70.1l.26.26c-4.73,0-9.45.16-14.18.17l-14.18.06.49-.49,0,11.18-.44-.44c4.67,0,9.34.08,14.06.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.1,95.39,423,95.68c-4.74.08-9.52.16-14.3.16h-.45v-.45l0-11.18V83.7h.5l14.18.06c4.73,0,9.46.12,14.19.17h.27v.27Zm0,0-.27-11.18.27.26c-4.73,0-9.46.16-14.19.17l-14.18.06.5-.49-.05,11.18-.45-.44c4.67,0,9.35.08,14.07.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.27,81.29l-14.07.28c-4.73.08-9.51.16-14.3.16h-.44v-.45L62.41,70.1v-.51h.5l14.19.06c4.73,0,9.45.12,14.18.17h.27v.27Zm0,0L91,70.1l.26.26c-4.73,0-9.45.16-14.18.17l-14.19.06.5-.49,0,11.18-.45-.44c4.68,0,9.35.08,14.07.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.41,176.41l-14.06.28c-4.74.08-9.52.16-14.3.17h-.45v-.45l0-11.19v-.5h.5l14.18.06c4.73,0,9.46.12,14.18.17h.27v.26Zm0,0-.26-11.19.26.26c-4.72.06-9.45.16-14.18.17l-14.18.07.5-.5-.05,11.19-.45-.45c4.67,0,9.35.08,14.06.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.8,
    width: 1,
    height: 138.61,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.89 185.45 149.98 194.04 60.61 194.04 56.72 185.45 94.76 159.11 115.84 159.11 153.89 185.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.48 133.74 115.84 159.11 94.76 159.11 92.12 133.74 118.48 133.74",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.88 185.45 149.97 194.04 60.61 194.04 56.71 185.45 153.88 185.45",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.15,
    width: 1,
    height: 83.17,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.23 130.01 254.33 138.6 164.96 138.6 161.07 130.01 199.11 103.67 220.19 103.67 258.23 130.01",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.83 78.3 220.19 103.67 199.11 103.67 196.47 78.3 222.83 78.3",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.23 130.01 254.32 138.6 164.96 138.6 161.06 130.01 258.23 130.01",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "443.29 455.13 394.96 455.37 346.64 455.46 250 455.62 153.36 455.46 105.03 455.37 56.71 455.13 105.03 454.88 153.36 454.79 250 454.63 346.64 454.79 394.96 454.88 443.29 455.13",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.2,455.12H138.94c-.79-3.1-1.56-6.15-2.33-9.15-.88-3.45-1.75-6.82-2.58-10.1-.18-.73-.37-1.47-.56-2.19q-.94-3.76-1.86-7.34l-1.09-4.29c-.38-1.44-.73-2.86-1.08-4.24-.1-.36-.19-.73-.28-1.08l-.3-1.19-.36-1.42h0c-.14-.5-.26-1-.38-1.48-.25-.93-.48-1.84-.7-2.73-.34-1.32-.67-2.61-1-3.87-.14-.55-.29-1.1-.42-1.63q-.34-1.32-.66-2.58c-.14-.56-.28-1.11-.41-1.65-.58-2.2-1.1-4.28-1.59-6.22l-.39-1.5c-.21-.84-.41-1.64-.61-2.42-.13-.49-.26-1-.37-1.43-.42-1.66-.81-3.17-1.14-4.5-.1-.36-.19-.7-.27-1-.22-.88-.43-1.66-.6-2.35-.07-.28-.13-.55-.21-.8s-.13-.53-.19-.76-.09-.35-.12-.49-.12-.47-.17-.66-.05-.21-.08-.29c-.14-.58-.22-.87-.22-.87h93.7s3.09,10.64,8,27.79c1,3.49,2.08,7.26,3.24,11.26C227.24,427.33,231.07,440.67,235.2,455.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.7,455.12h-2.4Q146.95,433,141.94,410.8q-1.22-5.4-2.39-10.81c-.07-.34-.15-.67-.22-1a.14.14,0,0,1,.28-.07c0,.11.06.22.1.33,1.08,3.86,2.17,7.74,3.23,11.62Q149,432.92,154.7,455.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.65,376.85l-4.13,20.7-3.39,17-5.77,28.94-.6,3-1,4.94-.74,3.75h-55.1c-.78-3.11-1.57-6.16-2.32-9.15-.88-3.45-1.75-6.82-2.58-10.1-.18-.73-.37-1.47-.56-2.19q-.94-3.76-1.86-7.34l-1.09-4.29c-.38-1.44-.73-2.86-1.08-4.24-.1-.36-.19-.73-.28-1.08l-.3-1.19-.36-1.42h0c-.14-.5-.26-1-.38-1.48-.25-.93-.48-1.84-.7-2.73-.34-1.32-.67-2.61-1-3.87-.15-.56-.29-1.1-.42-1.63q-.34-1.32-.66-2.58c-.14-.56-.28-1.11-.41-1.65-.58-2.2-1.1-4.28-1.59-6.22l-.39-1.5c-.21-.84-.41-1.64-.61-2.42-.13-.49-.26-1-.37-1.43-.42-1.66-.81-3.17-1.14-4.5-.1-.36-.19-.7-.27-1-.22-.88-.43-1.66-.6-2.35-.07-.28-.13-.55-.21-.8s-.13-.53-.19-.76-.09-.35-.12-.49-.12-.47-.17-.66-.05-.21-.08-.29c-.14-.58-.22-.87-.22-.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.67,376.81v0c0,.51-.39,6.1-1.3,14.63-.25,2.49-.56,5.22-.91,8.15-.55,4.62-1.23,9.72-2.08,15.11-1.44,9.4-3.31,19.66-5.75,29.69-.87,3.61-1.82,7.19-2.83,10.69l-121,0c1.42-18.43,2.73-35.1,3.77-48.24C81.07,388.43,82,376.85,82,376.85l109.71,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.41,387.93c-.13,4.33-.32,8.65-.6,12.95-.29,4.67-.72,9.33-1.33,14a4.6,4.6,0,0,1-.06.52q-.85,6.54-2,13.06c-.7,4.05-1.21,8.42-3,12.16a11.93,11.93,0,0,1-2.83,3.82,8.32,8.32,0,0,1-3.87,2,4.33,4.33,0,0,1-.72.12c-.06,0-.13,0-.21,0a.26.26,0,0,1,.14.25c-.05,1.45,0,2.93-.17,4.37a1.13,1.13,0,0,0,0,.18c-.14,1.26-.38,2.5-.61,3.75h-2.07s0-.05,0-.08c.37-1.36.67-2.74,1-4.12s.83-2.78,1.16-4.21a.27.27,0,0,1,.1-.13,6.46,6.46,0,0,1-6.24-3.92c-.7-1.85-.38-3.78-.1-5.68.38-2.48.74-5,1.12-7.43.71-4.55,1.62-9.05,2.43-13.58l.36-2.06c1.63-9.21,3.32-18.42,5.36-27.54.07-.38.16-.76.24-1.14s.47-.18.44.06c-.06.61-.12,1.23-.19,1.84-.36,3.51-.77,7-1.26,10.47-.59,4.09-1,8.2-1.56,12.28-.2,1.4-.39,2.79-.6,4.18-.94,6.72-1.91,13.44-3.06,20.14-.54,3.11-2.48,8.68,2,9.65a4.6,4.6,0,0,0,3-.38,9.54,9.54,0,0,0,4.16-5.26c1.27-3.56,1.72-7.49,2.38-11.2.73-4.1,1.37-8.2,1.95-12.31h0q1.1-7.69,2.29-15.38c.4-2.61.82-5.22,1.23-7.83.2-1.21.39-2.42.59-3.63C209,387.6,209.41,387.67,209.41,387.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.38,420.08a60.66,60.66,0,0,0,14.92-2c2.25-.57,4.47-1.29,6.67-2a17.07,17.07,0,0,0,6-3c3.4-2.92,5-7.53,6.45-11.62a111.28,111.28,0,0,0,3.91-14.11c.05-.24.4-.16.4.06a54.54,54.54,0,0,1-2,16c-1.21,4.43-2.85,9.36-6.42,12.46-3.76,3.26-8.87,4.41-13.68,5a63.13,63.13,0,0,1-16.25-.22A.27.27,0,0,1,102.38,420.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,387.44q-.41,10.15-.86,20.32-1,23.69-2.28,47.36H88.59q1.56-23.73,3.29-47.43c.5-6.76,1-13.5,1.53-20.26A.3.3,0,0,1,94,387.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,257.48c19.11,28.83,65.89,81.86,89.48,89.53,13.6,4.43,71-5.42,84.29-9.21,7.06-2-19.83-59.65-27.43-57.71-7.79,2-43.73,9.43-49.58,9.7s-51.63-33.73-75.48-49.18C173.2,221.13,166.36,233.87,182,257.48Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.6,339.47c7.39-.92,41.32-8,50.18-12.09s33.52-17.71,31.07-24.82-10-3.69-10-3.69,9.5-7.4,6.39-14.33-14.66-1.24-14.66-1.24,9.2-8.31,5.6-15-14.26,1-14.26,1,8.77-7.21,3.49-11.47c-6.36-5.13-21,10-31.14,13.76-2.3.86-47.83,14.1-47.83,14.1Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.87,268.65c-10.81,11.08-17.45,14.07-32.27,17.62-.29.07-.26.51,0,.47,14.84-2.16,23.71-4.7,32.79-17.6C402.88,268.51,402.39,268.12,401.87,268.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.44,282.41C398.21,293,391,296.24,375.78,301.11c-.22.06-.12.44.1.39,15.36-3.52,24.16-6.26,35-18.39C411.36,282.56,411,281.93,410.44,282.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.09,299.09c-12.58,9.35-20.3,13.3-35.71,16.12a.29.29,0,0,0,.07.57c16-1.34,25.66-6.21,35.88-16.28C418,298.82,417.88,298.5,417.09,299.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,287.78s10.74-16.16,17-22.22,38-20,41.41-13.33c4.4,8.62-12.33,20.29-21.27,24.93,0,0,10.18,19.94,0,30.91S316,287.78,316,287.78Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.81,255c-1.66,10.76-13.79,16.1-22.13,21.25a.89.89,0,0,0-.14,1.46c3.71,8.65,6.42,21.92,1.17,30.35a.23.23,0,0,0,.37.27c6.85-8.27,5.25-21.53.58-30.74,8.63-5.15,20.56-11,20.26-22.58C374.92,254.94,374.82,254.92,374.81,255Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.45,261.66,219.94,316.6s-36.75-48.43-48.27-71.35c-12-23.88-6.94-32.49,23.48-14.39C225.76,249.07,242.45,261.66,242.45,261.66Z",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.45,261.66l-10.69,26.09L219.94,316.6s-36.74-48.43-48.27-71.35c-6.1-12.11-7.79-20.29-4-23.05s12.52-.26,27.51,8.66C225.76,249.08,242.45,261.66,242.45,261.66Z",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.36,221.69c.35.08.71.17,1.08.28l-.94.66c-3.25,2.33-6.44,4.75-9.61,7.22,0-.28-.09-.55-.11-.81C168.91,226.54,172.05,224,175.36,221.69Zm32.31,16.78a38.53,38.53,0,0,1-4.65,8.34,49.22,49.22,0,0,1-13.78,12.77,51.12,51.12,0,0,1-7,3.67c.18.29.38.58.56.88a55.71,55.71,0,0,0,7.23-3.87,50.39,50.39,0,0,0,13.37-12.38,38.8,38.8,0,0,0,5.05-8.92Zm4.68,68,1,1.4c.17.07.35.17.52.25a58.39,58.39,0,0,1,7.66,4.53l.37-.89c-.87-.6-1.75-1.18-2.66-1.74A51.48,51.48,0,0,0,212.35,306.43Zm21.18-28.76c-8.16-1.84-15.63-5.91-23.88-7.45-6.72-1.26-13.9-.51-19.22,4.13-.17.16-.35.31-.51.49.17.25.36.52.53.79a18.29,18.29,0,0,1,9.05-4.69c8.34-1.65,16.68,1.85,24.36,4.69A65.33,65.33,0,0,0,235.34,279l.38-.93C235,278,234.25,277.83,233.53,277.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.48,261.49c-.69,1.24-1.2,2.59-1.77,3.89s-1.17,2.67-1.76,4c-1.19,2.7-2.33,5.43-3.46,8.16-2.26,5.46-4.54,10.91-6.7,16.41-.6,1.51-1.19,3-1.74,4.55s-1.06,3.26-1.64,4.85c0,.1.11.15.15.05.6-1.33,1.31-2.62,1.92-4s1.22-2.74,1.81-4.13c1.15-2.72,2.29-5.45,3.4-8.18,2.18-5.4,4.38-10.78,6.45-16.22.58-1.52,1.14-3,1.72-4.56s1.31-3.18,1.76-4.81C231.65,261.47,231.52,261.41,231.48,261.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.76,287.75,219.94,316.6s-36.74-48.43-48.27-71.35c-6.1-12.11-7.79-20.29-4-23.05,6.09.17,10.31.27,10.31.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.12,414.41,72,414.86s13.53-116.73,70.5-185.69c13.18-16,34.41-7.28,43.36,1.19C208.56,251.87,227.56,413.85,227.12,414.41Z",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.69,223.21c-6.63,4.79-13,10-19.45,15-3.33,2.57-6.57,5.3-10.05,7.65-2.79,1.88-6,3.44-9.42,3.25a10.91,10.91,0,0,1-6.17-2.49c.11-.18.24-.37.36-.55a11.33,11.33,0,0,0,2.34,1.46c3.43,1.57,7.16.79,10.35-1,3.53-1.94,6.64-4.69,9.82-7.15l10.41-8.08c3.59-2.78,7.15-5.78,10.88-8.5Zm-23,79.94c3.43-4.91,5.1-11.5,3-17.26-1.93-5.15-6.54-8.54-11.77-9.8A23.77,23.77,0,0,0,126.74,278c-6.53,3.31-11.28,9.19-17.15,13.44a28,28,0,0,1-5.31,3c-.17.41-.33.81-.5,1.21,6.32-2.39,11-7.43,16.07-11.73a34.32,34.32,0,0,1,8.89-5.85,23.3,23.3,0,0,1,8.64-1.71c5.68-.06,11.74,2.06,15,7,3.68,5.55,2.6,12.75-.75,18.18-8.49,13.76-27.28,12.88-41.32,13.14a81.73,81.73,0,0,0-14.37,1.35c-.15.37-.28.73-.4,1.1a88.18,88.18,0,0,1,16.36-1.45C125.57,315.52,142.93,315.74,151.73,303.15Zm3.43-34.78A53.42,53.42,0,0,0,190,260.26a51.93,51.93,0,0,0,7.73-6c-.11-.35-.22-.69-.35-1a49.47,49.47,0,0,1-8.18,6.37A52.15,52.15,0,0,1,153.18,267c-10.31-1.76-19.56-8.1-29.57-10.9-.2.31-.38.62-.58.93a90.8,90.8,0,0,1,12.66,5C142,264.89,148.27,267.51,155.16,268.37Zm-11.51,94.14a24,24,0,0,0,7-15.55c.3-5.37-1.41-11-5.68-14.55-4.9-4-11.56-4.18-17.36-2.3-6.69,2.17-11.88,6.8-16.42,12-4.94,5.69-9.27,12.17-15.28,16.82-4.09,3.16-9.24,5.75-14.51,6.09-.08.31-.15.62-.23.93A23.54,23.54,0,0,0,89,364.14c6.6-2.78,11.6-7.75,16.12-13.16,4.76-5.67,9.2-12,15.41-16.28,5.42-3.71,12.65-6.13,19.15-4.07,6.06,1.91,9.56,7.52,10,13.67a22.57,22.57,0,0,1-6,16.7c-4.83,5.26-11.36,8.53-18,11a201.55,201.55,0,0,1-23.49,6.82c-8.47,2-18.66,3.7-25.76,9.11-.1.53-.21,1-.3,1.54,7.11-5.95,18-7.72,26.8-9.79a195,195,0,0,0,23.4-6.82C132.63,370.47,138.86,367.36,143.65,362.51Zm-10,25.67c-6.83-.46-12.65,3.81-16.51,9.07-4,5.46-6.38,11.88-10.08,17.51h1.12c1.51-2.37,2.81-4.89,4.07-7.32,3.28-6.35,6.88-13.47,13.62-16.76a14.59,14.59,0,0,1,10.31-1.16,11.24,11.24,0,0,1,6.91,6.42c2.6,5.89,1.62,12.46,2,18.69v0h1c-.3-5.09.23-10.24-.88-15.28C143.9,393.53,140,388.6,133.69,388.18ZM204,410.52c-2.32-6.31-2.35-13.17-2-19.79.78-16.62,4.05-33.39,1.44-50-2-12.72-7.46-25.62-18.23-33.31-5.48-3.9-13-6.41-19.22-2.71-5.28,3.12-8.05,9.44-8.12,15.4-.09,7.72,3.51,14.95,7.29,21.47s8,12.56,11.8,19,7,13.07,8.39,20.34a46.8,46.8,0,0,1-.65,20.36,48.35,48.35,0,0,1-5.54,13.28l1.13,0c.51-.86,1-1.74,1.45-2.62a48.62,48.62,0,0,0,2.48-38.64c-5.1-14-15.36-25.31-21.69-38.73-3.24-6.86-5.33-15-1.94-22.24a15.14,15.14,0,0,1,6.44-7.09,14,14,0,0,1,10.94-.51c6.68,2.19,12.25,7.58,16.09,13.32a54.51,54.51,0,0,1,7.58,18.56c3.56,16.13.75,32.71-.4,48.94-.5,7-.93,14.17.57,21.09a26.75,26.75,0,0,0,2.93,7.85H206A20.16,20.16,0,0,1,204,410.52ZM187.2,290.89c3.24,6.58,9.81,10.16,16.33,12.83,2.42,1,4.86,1.91,7.25,2.93-.06-.34-.13-.67-.19-1-3.79-1.61-7.65-3-11.35-4.9-6.29-3.16-12.8-8.86-12.71-16.52.08-7,6.56-12,13-13.3a23.42,23.42,0,0,1,3.1-.38c-.08-.27-.16-.56-.23-.84a19.71,19.71,0,0,0-11.94,4.63A13.48,13.48,0,0,0,187.2,290.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.48,270.41c0,38.07,12.09,118.12,34,135.56,28.76,22.89,88.73,27.13,107.72,27.59,8.28.2,12.87-54.74,6.42-60.81s-75.49-18.56-81.46-21.42-25.31-58.71-40.77-86.82C142.89,229.05,136.48,238.42,136.48,270.41Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.49,383.68c-3.62-2.17-2.51-4.08,4.94-5s37.72,1.62,37.72-9-42.76-13.65-55-11.12-31.25,10.91-31.25,10.91C275.06,371.69,294.45,379.05,310.49,383.68Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,431.31c23.35,5.51,52.07,13.78,77.92,5.77a13.41,13.41,0,0,0,7.2-5c11.65-3.39,13.55-9.9,13.55-9.9,9.89-6.48,10.92-13.41,10.92-13.41s13.63-4.12,12.51-12.78c-1.23-9.71-20.14-2-33.12-4.15-29.75-4.88-70.66-20.14-79.1-22.4Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.19,408.63c8.78,1.26,17.38,2.73,26.29,2.79,9.77.07,19.18-1.5,28.81-2.85a.24.24,0,0,1,.1.46c-17,5.21-38.17,4.9-55.26,0C310.71,408.91,310.75,408.56,311.19,408.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.64,426.15c8.61.75,23.76,2,49.95-4.27.08,0,.15.12.06.16-16.47,6.32-32.82,7.5-50,4.52C305.07,426.47,305.06,426.1,305.64,426.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.83,435.62c14.69.73,24.05-.68,39.2-3.6.09,0,.14.12.05.15-16.87,5.14-23.58,5.09-39.35,4C302.19,436.09,302.25,435.6,302.83,435.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.57,307.66,136.3,342.23s-5.38-60.55-3-86.09c2.52-26.61,11.39-31.21,27.53.29C177.12,288.13,184.57,307.66,184.57,307.66Z",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.07,334.53l-.85.6a13.48,13.48,0,0,0-6.54-4.5,16.33,16.33,0,0,0-4.37-.74l-.06-.92a15.85,15.85,0,0,1,9.74,3.44A13.88,13.88,0,0,1,147.07,334.53Zm-1.88-88.68c2.18-1.48,4.28-3.1,6.35-4.75-.14-.21-.31-.4-.46-.6a61.49,61.49,0,0,1-8.43,6.05,12.28,12.28,0,0,1-8.25,1.63c0,.23-.09.47-.13.71a10.83,10.83,0,0,0,1.5.21C139.2,249.29,142.4,247.73,145.19,245.85Zm-2.28,30.24a23.66,23.66,0,0,0-10.19-.15c0,.33,0,.65,0,1a22.75,22.75,0,0,1,4.65-.5c5.68-.06,11.74,2.06,15,7,3.68,5.55,2.6,12.75-.75,18.18-4,6.53-10.39,9.76-17.45,11.39l.06,1c6.93-1.58,13.23-4.67,17.51-10.79,3.43-4.91,5.1-11.5,3-17.26C152.75,280.74,148.14,277.35,142.91,276.09Zm23.5-8.66a48.87,48.87,0,0,1-13.23-.42c-7-1.2-13.52-4.51-20.12-7.38l-.06,1.21,2.69,1.21c6.27,2.84,12.58,5.46,19.47,6.32a50.66,50.66,0,0,0,11.74.05Zm17.82,39.34c-5.36-3.51-12.37-5.53-18.23-2-5.28,3.12-8.05,9.44-8.12,15.4a26.92,26.92,0,0,0,.67,6.16l.9-.63a20.8,20.8,0,0,1,1.15-13.35,15.14,15.14,0,0,1,6.44-7.09,14,14,0,0,1,10.94-.51,24.59,24.59,0,0,1,6.29,3.16l.3-.21S184.46,307.36,184.23,306.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.37,301.68c-1.24.69-2.4,1.56-3.57,2.36l-3.62,2.46c-2.45,1.66-4.86,3.36-7.27,5.08-4.82,3.42-9.64,6.83-14.4,10.33-1.31,1-2.61,1.93-3.89,2.93s-2.62,2.2-4,3.24c-.09.06,0,.18.1.12,1.22-.81,2.51-1.52,3.73-2.33s2.5-1.67,3.73-2.53q3.63-2.54,7.23-5.13c4.71-3.41,9.44-6.8,14.08-10.3l3.88-3c1.36-1,2.8-2,4-3.14C175.52,301.76,175.45,301.64,175.37,301.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.41,270c0-.12-.22-.06-.2.06a44.69,44.69,0,0,0,1.57,6.73c-.46-.95-.9-1.91-1.37-2.86-1.51-3.06-3.07-6.1-4.57-9.16a.1.1,0,0,0-.18.08c2.25,5.51,4.28,11.13,6.7,16.58s4.83,10.89,7.33,16.3c1.38,3,3.31,6.56,4.7,9.54-1.25,1.2-3.09,2.41-4.46,3.68-.12.11.07.29.21.2,1.59-1.13,3.71-2.19,5.27-3.54.2-.17-8.32-19.65-12.66-28.78C172.05,275.82,171.29,272.86,170.41,270Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.8,337.32a37.17,37.17,0,0,0-4,2.06c-1.07.63-2.07,1.35-3.09,2,0-1.72-.21-3.45-.32-5.16q-.21-3.06-.41-6.12c-.27-4.08-.55-8.16-.8-12.24s-.54-8.16-.78-12.25-.42-8.17-.75-12.25c-.37-4.59-.71-9.19-1.06-13.78a.16.16,0,0,0-.32,0q-.08,6.36,0,12.72c-.62-2.43-1.44-4.82-1.94-7.28a.15.15,0,0,0-.3.05c.21,3.17.68,6.56,2.29,9.35.08,3.31.18,6.63.35,9.95.41,8.17.91,16.33,1.61,24.49.2,2.29.4,4.58.62,6.88s.34,4.54.77,6.75a.52.52,0,0,0,.87.21,33.41,33.41,0,0,1,3.6-2.77c1.2-.86,2.43-1.68,3.67-2.48C144,337.44,143.9,337.28,143.8,337.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.66,235.19a70.52,70.52,0,0,1-.12,7.41,35.35,35.35,0,0,1-.88,6.61c-1,3.93-3.39,7.74-7.62,9.3a15.53,15.53,0,0,1-12-1c-3.91-1.92-7.15-4.94-10.14-7.89-1.85-1.83-3.63-3.73-5.31-5.7-.85-1-1.7-2-2.5-3s-1.55-2.11-2.41-3.1c-.07-.08-.24,0-.18.1,1.72,2.37,7,9.9,8.63,11.72,3,3.31,6.3,6.67,10.38,8.89a17.4,17.4,0,0,0,13,1.82,12.8,12.8,0,0,0,8.79-8.84,26.57,26.57,0,0,0,.92-7.71c0-2.86-.17-5.72-.41-8.55C190.72,235.15,190.66,235.16,190.66,235.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.64,251.9c-9.53.94-23.47-15.28-28.19-27.53-.32-.84,7.14-31.71,8-38,.16-1.28,38.09,14.85,38.09,14.85s-5.64,12.62-7,23.56C188.38,225.72,186.84,251,177.64,251.9Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.53,201.24s-5.64,12.62-7.05,23.56c0,.22-.13,1.8-.39,4.09-18.48-4.24-28.84-17.32-34-26.42,1.56-7,3-13.53,3.32-16.07C157.61,185.11,195.53,201.24,195.53,201.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.08,125.06c2.29-.28,14.9,14.92,16.14,22.87s.72,24.22-1.58,24.84S192.31,125.28,194.08,125.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.71,147.67c-3.93,14.17,4.58,54.6,14.83,63.4,14.87,12.74,38.67,13.37,49.39-4.36,10.38-17.18-1.63-69.68-13-77.61C178.1,117.41,149.51,126.72,143.71,147.67Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.29,162.94a35.81,35.81,0,0,1-3.33,1.55c-1.29.59-2.25,1.19-3.7.95a1.89,1.89,0,0,1-1.39-1.85c.13-1.79,1.52-2.9,3-3.67a6.88,6.88,0,0,1,4.93-.65A2,2,0,0,1,178.29,162.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.84,171.93c0-.09-.18.18-.14.29.76,2.69,1.19,5.88-1,7.4-.07,0,0,.18.06.14C181.6,178.59,181,174.35,179.84,171.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.72,169.72c-4.43.76-2.58,9.56,1.53,8.86S180.43,169.08,176.72,169.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.46,168.25c0-.11.24.08.26.19.49,2.75,1.51,5.81,4.17,6.2.08,0,.1.15,0,.15C196.8,175,195.48,170.93,195.46,168.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.3,164.89c4.31-1.26,6.51,7.47,2.51,8.63S193.68,165.94,197.3,164.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5,159a34.93,34.93,0,0,1-3.69-.17c-1.42-.09-2.55,0-3.73-.9a1.9,1.9,0,0,1-.37-2.29c.95-1.53,2.7-1.86,4.41-1.84a7,7,0,0,1,4.69,1.73A2,2,0,0,1,199.5,159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.87,197c.78.5,1.62,1.24,2.63,1.11a7.38,7.38,0,0,0,2.78-1.3.1.1,0,0,1,.15.12,3.78,3.78,0,0,1-3.15,2.21,3,3,0,0,1-2.65-2C182.55,197.07,182.75,197,182.87,197Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,188.27a9.52,9.52,0,0,0,7.07,2.83,12.12,12.12,0,0,0,3.37-.55,3.11,3.11,0,0,0,.63-.21l.57-.22a.68.68,0,0,0,.42-.72v0a1.52,1.52,0,0,0-.09-.28v0l-.06-.24c-.38-2.11-1.26-5.26-1.26-5.26.85.23,5.13,1.16,4.84.08-2.45-9-5.18-18.94-9.51-27.34a.26.26,0,0,0-.49.17c2,8.71,5.55,17,7.72,25.73-1.35-.22-3.57-.66-4.66-.41-.28.15,1.8,6.06,1.89,7a.45.45,0,0,1,0,.1c-3.44,1.2-6.32.69-10.24-1C184,187.86,183.8,188.09,184,188.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,189.74a11.21,11.21,0,0,1-3.69,4.35,5.1,5.1,0,0,1-3,.82c-2.3-.11-2.77-2.1-2.73-3.89a11.82,11.82,0,0,1,.42-2.83A14.57,14.57,0,0,0,193,189.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.3,194.09a5.1,5.1,0,0,1-3,.82c-2.3-.11-2.77-2.1-2.73-3.89C186,190.76,188.62,191.86,189.3,194.09Z",
    style: {
      fill: "#ff97b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.31,182.88c7.34-.53,9.59-9.14,10.25-20.8.39-6.81-3.47-19.62-3.47-19.62s19.88,5.67,30.21,3,17.82-13.09,16-21.23c-1.55-7-14.92-14.24-30.68-12.37-11,1.3-28,13-34.24,26.09,0,0-12.67,8.78-8.95,18.83S141,183.48,149.31,182.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.69,182c9.85.48,12.57-14.68,11.6-22.19-1-7.8-5.27-15.17-7.84-22.53,0,0,0-.06.06,0,4.71,8.67,10.07,19.74,8.5,29.86-1,6.37-3.82,17.1-12.35,15.43C149.37,182.45,149.38,182,149.69,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.85,154c.31-6.6,6.57-14.08,12.44-16.57.05,0,.09.07,0,.1-6.87,3.85-14,13.65-10.38,21.47,2.88,6.25,7.42,14.37,12.73,18.84.14.12,0,.31-.18.21-4.08-2.94-6.36-7.27-8.93-11.5C129.33,162.9,125.64,158.6,125.85,154Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.16,139.18c6.6-13.75,22.93-30.8,39.43-29.58,0,0,0,.08,0,.08-17.27.16-30.16,17-38.78,29.93C136.55,140,136,139.57,136.16,139.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,182.57s-9.69-12.79-15.54-9.29,1.79,22.28,8.89,24.62a7.13,7.13,0,0,0,9.4-4.18Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.77,178.61c-.11,0-.12.15,0,.19,5,1.8,7.75,6.25,9.73,10.9-1.52-1.76-3.55-2.68-5.92-.85-.13.1,0,.29.14.26a4.37,4.37,0,0,1,4.88,1.34,21.19,21.19,0,0,1,2.46,3.81c.24.43,1,.17.84-.33,0,0,0-.08,0-.11C152.72,187.56,147.52,179,140.77,178.61Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451,358.37c-13.22,17.91-27,38.69-30.37,61.15,0,.34.51.45.59.12a133,133,0,0,1,5.84-18c8.7-2.39,17.23-4.35,21.8-13,4.65-8.87,4.06-20.44,3.18-30.1C451.93,358.05,451.22,358,451,358.37Z",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.15,401.49c5.94-13.34,13.56-26.72,23.26-37.68.06-.08.16,0,.1.1-6.34,7.81-11.17,16.31-15.88,25,4.38-4.44,9.18-8.42,13.33-13.14.08-.09.21,0,.13.14-4.12,4.94-8.62,10.31-14,14q-2.16,4-4.36,8c.36-.2.73-.38,1.1-.57.07,0,.12.07.06.1-.41.21-.82.43-1.24.6-.69,1.26-1.38,2.53-2.1,3.78C427.41,402,427,401.77,427.15,401.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.57,396.83a78.24,78.24,0,0,0,10.15-6.77c.08-.07.21.05.12.12a53.28,53.28,0,0,1-10.13,6.9A.14.14,0,0,1,431.57,396.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.05,416.19a.25.25,0,0,0,.49,0c.07-7.39,0-14.82.11-22.25,1.9-3.83,6-5.94,8.79-9a39.2,39.2,0,0,0,5.28-7.34,52.78,52.78,0,0,0,6.12-20.41c.78-7.91-2.22-34-5.56-33.11-1.73.47-7.32,13.4-8.81,17.68a123.17,123.17,0,0,0-5.26,21.67C417.51,380.8,417.73,398.67,419.05,416.19Z",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,384.28l0,0c.41-9.36,2.52-18.81,4.49-27.89,2.13-9.78,4.61-19,9.64-27.71a.15.15,0,0,1,.25.15,102.87,102.87,0,0,0-7.74,21.27c.33-.53.74-1,1.09-1.53.14-.19.47,0,.33.19a13.46,13.46,0,0,1-1.57,2.22.11.11,0,0,1-.07,0c-1.73,7-3,14.14-4,21.27l.24-.27a.07.07,0,0,1,.11.08c-.13.24-.28.47-.43.71-.53,3.62-1,7.23-1.53,10.81,6.45-5.51,11.95-12,15.06-20,0,0,.07,0,.06,0-3.05,8.3-7.84,15.67-15.22,20.71-.14,1-.27,1.93-.41,2.89,0,.2-.34.14-.34-.05,0-.85,0-1.71.07-2.56A.2.2,0,0,1,419,384.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,370.72c4.92-7.35,9.52-14.49,13.13-22.62,0-.09.19,0,.16.07-3,8.07-7.29,16.25-13.05,22.74C422.17,371,421.94,370.87,422,370.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.58,346.29c2-3.61,4.19-7.13,6.11-10.81.06-.1.2,0,.16.09a57,57,0,0,1-6,10.9C428.76,346.66,428.46,346.5,428.58,346.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.79,347.86a0,0,0,0,1,0,.06A0,0,0,1,1,427.79,347.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.05,394.79a75.82,75.82,0,0,1-1.73,14.58c.08.52.15,1.05.23,1.59a69.48,69.48,0,0,0,2.6-16.24.49.49,0,0,0,0-.5v0a107,107,0,0,0-1.64-22c-2.29-13.59-7.29-26.64-16.77-36.82a.67.67,0,0,0-1,.21c-3.82,9.73-2.49,21.34.77,31A56.37,56.37,0,0,0,404,381.36C407.26,385.93,411.41,389.8,414.05,394.79Z",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.89,339.92c9,14.58,15.24,31.87,16,49.09,0,.31-.5.39-.54.08-.22-1.55-.45-3.09-.7-4.61h0c-3.72-3.56-7.54-7.31-10.2-11.76-.05-.08.07-.17.13-.1a123.12,123.12,0,0,0,9.9,10.77c-.64-3.8-1.4-7.55-2.31-11.24l-.71-.84c-.15-.18.11-.45.27-.27l.21.24a129.51,129.51,0,0,0-4.69-14.91c-2.29-2.73-4.85-5.09-6.51-8.37,0-.08.06-.14.12-.07,1.34,1.88,2.63,3.77,4.15,5.51.61.7,1.27,1.35,1.9,2a115.57,115.57,0,0,0-7.36-15.33A.2.2,0,0,1,397.89,339.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.71,357.91c2.9,3.9,6.21,7.63,8.91,11.67.08.12-.09.24-.19.15C405,366.47,402,362,399.51,358,399.43,357.89,399.62,357.79,399.71,357.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,370.49l.12.12c.09.09,0,.22-.13.13l-.13-.12A.1.1,0,0,1,409,370.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.81,368c.73,7.5,4.67,16.46,9.48,22.24a23.54,23.54,0,0,0,7.69,6c3.33,1.65,6.82,3.55,10.26,4.9a67.48,67.48,0,0,1,3.64,12.9c.11-.37.22-.76.33-1.14-2.21-19-14.5-35.23-30.22-45.65A.77.77,0,0,0,383.81,368Z",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.25,373.56c-.11-.1,0-.3.16-.21a64.43,64.43,0,0,1,20,24.69c.11.26-.24.49-.39.23-.73-1.28-1.48-2.53-2.24-3.75h0c-3.59-.67-7-3.2-9.65-5.6-.07-.06,0-.17.11-.1A22.49,22.49,0,0,0,401.8,392c1.46.74,3,1.21,4.56,1.8-1.33-2.11-2.72-4.13-4.16-6.1a41.52,41.52,0,0,1-10.79-6.06c-.1-.07,0-.24.1-.17a108.66,108.66,0,0,0,10,5.36,88.89,88.89,0,0,0-7.08-8.25c-1.22-.65-2.46-1.3-3.64-2-.09-.06,0-.22.08-.19a13.6,13.6,0,0,1,2.79,1.37C392.27,376.36,390.81,374.94,389.25,373.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.58,380.12a4.35,4.35,0,0,1,.6.43c.06.05,0,.13-.07.1a3.94,3.94,0,0,1-.63-.36C389.37,380.22,389.47,380.05,389.58,380.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.74 455.13 396.67 455.13 400.14 415.89 400.91 407.24 435.5 407.24 436.27 415.89 439.74 455.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.27 415.89 400.14 415.89 400.91 407.24 435.5 407.24 436.27 415.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.85,
    y: 401.19,
    width: 38.72,
    height: 8.56,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.36,87.3a82.36,82.36,0,0,1-.68-9.53,80.19,80.19,0,0,1,.33-9.54,80.18,80.18,0,0,1,.67,9.53A82.35,82.35,0,0,1,351.36,87.3Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.83,99.44a80.67,80.67,0,0,1-5.35-7.91A81.71,81.71,0,0,1,298,83.11,78.94,78.94,0,0,1,303.34,91,79.82,79.82,0,0,1,307.83,99.44Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.21,131.72a81,81,0,0,1-8.59-4.17,79.31,79.31,0,0,1-8.1-5.06,82.09,82.09,0,0,1,8.59,4.18A81,81,0,0,1,276.21,131.72Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,175.49a82.19,82.19,0,0,1-9.52.68,80,80,0,0,1-9.54-.33,92,92,0,0,1,19.06-.35Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.11,219a81.79,81.79,0,0,1-7.91,5.34,79,79,0,0,1-8.43,4.49,80,80,0,0,1,7.91-5.34A79,79,0,0,1,277.11,219Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.3,217.46A89.76,89.76,0,0,1,445,226.69a92.22,92.22,0,0,1-16.69-9.23Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.55,173.69a80.16,80.16,0,0,1,9.52-.67,78,78,0,0,1,9.54.32,80,80,0,0,1-9.52.67A78,78,0,0,1,439.55,173.69Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.41,130.16a80.44,80.44,0,0,1,7.9-5.34,79,79,0,0,1,8.43-4.49,78.85,78.85,0,0,1-7.91,5.34A79.82,79.82,0,0,1,427.41,130.16Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.12,98.54A82.91,82.91,0,0,1,399.3,90a79.88,79.88,0,0,1,5.05-8.1,80.86,80.86,0,0,1-4.17,8.58A81.1,81.1,0,0,1,395.12,98.54Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "265.14 116.47 273.49 114.92 275.36 106.12 277.23 114.92 285.58 116.47 277.26 118.51 275.36 126.82 273.46 118.51 265.14 116.47",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.74 262.87 408.09 261.33 409.96 252.52 411.82 261.33 420.18 262.88 411.86 264.91 409.96 273.23 408.06 264.91 399.74 262.87",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.09 244.4 293.76 243.54 294.8 238.62 295.85 243.54 300.52 244.4 295.87 245.54 294.8 250.19 293.74 245.54 289.09 244.4",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.5 93.73 319.16 92.86 320.21 87.94 321.25 92.86 325.92 93.73 321.27 94.86 320.21 99.51 319.14 94.86 314.5 93.73",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.8,267.41a1.36,1.36,0,0,0,0-2.71A1.36,1.36,0,0,0,294.8,267.41Z",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.53,250.19a1,1,0,0,0,0-1.92A1,1,0,0,0,426.53,250.19Z",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.73,125.18a1,1,0,0,0,0-1.91A1,1,0,0,0,289.73,125.18Z",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.93,139.74a1,1,0,0,0,0-1.92A1,1,0,0,0,445.93,139.74Z",
    style: {
      fill: "#FF5924"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.67,148.54c3.34,0,3.34-5.19,0-5.19S430.32,148.54,433.67,148.54Z",
    style: {
      fill: "#FF5924"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-27"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.34,179c-3.68,46-42,59.87-42,59.87-2.82,7-6.49,24.79-6.49,24.79H326.67s-3.67-17.79-6.49-24.79c0,0-38.33-13.87-42-59.87-2.55-32,20.21-79.23,73.8-79.24h.55C406.12,99.81,428.89,147.07,426.34,179Z",
    style: {
      fill: "#FF5924"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,179.27C416.65,221.35,381.59,234,381.59,234c-2.58,6.4-5.93,29.67-5.93,29.67h-46.8s-3.36-23.27-5.94-29.67c0,0-35.06-12.68-38.42-54.76C282.17,150,303,106.81,352,106.8h.51C401.52,106.81,422.35,150,420,179.27Z",
    style: {
      fill: "#FF5924"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 186.79,
    width: 3,
    height: 81.95,
    transform: "translate(-36.16 64.86) rotate(-10.58)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.25,
    y: 226.26,
    width: 81.95,
    height: 3,
    transform: "translate(80.21 552.03) rotate(-79.46)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.26,214.12c-4.58,0-8.78-4.28-11.73-9.75a6,6,0,0,1-4.34,2.46c-7.47,0-10.49-15.52-10.62-16.18l1-.18c0,.15,3,15.36,9.63,15.36h0c1.32,0,2.65-.92,3.86-2.4a34.18,34.18,0,0,1-3.78-14.36c0-4.29,1.59-6.75,4.38-6.75h0c3.25,0,5.11,2.62,5.11,7.18a26.55,26.55,0,0,1-4.53,14c2.79,5.36,6.77,9.63,11,9.63h0c3.2,0,6.4-2.5,9-7,.23-.41.46-.83.68-1.26-3-3.22-4.67-8.5-4.67-13.53,0-5.53,2.06-9,5.37-9h0a3.43,3.43,0,0,1,3.07,1.89c2.24,3.87,1,13.17-2.57,20.45a7.47,7.47,0,0,0,5.26,2.21h0c5.7,0,10-15.3,10.06-15.45l1,.27c-.19.66-4.57,16.18-11,16.18h0a8.38,8.38,0,0,1-5.71-2.32l-.57,1C360.16,210,356.84,214.12,352.26,214.12Zm10.41-30.8h0c-3.23,0-4.37,4.29-4.37,8,0,4,1.34,9.34,4.13,12.59,3.25-6.89,4.47-15.67,2.45-19.17A2.43,2.43,0,0,0,362.67,183.32Zm-22,0h0c-2.94,0-3.38,3.6-3.38,5.75a33.13,33.13,0,0,0,3.47,13.44,25.33,25.33,0,0,0,4-13C344.76,187.19,344.22,183.32,340.65,183.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.21,
    y: 263.76,
    width: 64.1,
    height: 35.28,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,299c-3.77,6.69-11,12.67-24.78,12.67s-21-6-24.79-12.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,299a24,24,0,0,1-4.16,5.43l-44.12-3.39a23.23,23.23,0,0,1-1.29-2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.18 270.49 318.33 276.76 318.33 273.68 386.18 267.41 386.18 270.49",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.18 279.8 318.33 286.07 318.33 283 386.18 276.72 386.18 279.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.18 289.11 318.33 295.38 318.33 292.31 386.18 286.03 386.18 289.11",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.32,168.29c2.35.39,5.4-11.74,18.44-25.78,5.79-6.23,27.77-14,26.19-21.23s-21.19.2-31.06,11.63C292,151.3,292.16,167.92,294.32,168.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,170.81c4.32,0,4.33-6.72,0-6.72S405.63,170.81,410,170.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.81,221.33c2.36,1.81,13.83-8.78,19-21.41,4.3-10.48,5-23.73,2.15-24.5s-4.76,17.41-8.23,24.11C397.35,208,386.28,219.41,388.81,221.33Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginimage);
export default __webpack_public_path__ + "static/media/loginimage.c72093339cca16254f9f38c430b2cfeb.svg";
export { ForwardRef as ReactComponent };